(function () {
  var container = document.querySelector('.shopify-policy__container');
  if (!container) return;

  var titleWrap = container.querySelector('.shopify-policy__title');
  var body = container.querySelector('.shopify-policy__body');
  var rte = body ? body.querySelector('.rte') : null;
  if (!titleWrap || !body || !rte) return;

  var h1 = titleWrap.querySelector('h1');
  var pageTitle = h1 ? h1.textContent.trim() : document.title;

  var hero = document.createElement('div');
  hero.className = 'policy-hero-inject';

  var breadcrumb = document.createElement('p');
  breadcrumb.className = 'policy-breadcrumb';
  var homeLink = document.createElement('a');
  homeLink.href = '/';
  homeLink.textContent = 'Home';
  breadcrumb.appendChild(homeLink);
  breadcrumb.appendChild(document.createTextNode(' / ' + pageTitle));
  hero.appendChild(breadcrumb);

  var eyebrow = document.createElement('span');
  eyebrow.className = 'policy-eyebrow';
  eyebrow.textContent = 'Legal';
  hero.appendChild(eyebrow);

  container.insertBefore(hero, titleWrap);

  var dataEl = document.getElementById('policy-links-data');
  if (dataEl) {
    try {
      var links = JSON.parse(dataEl.textContent);
      if (links.length > 1) {
        var nav = document.createElement('nav');
        nav.className = 'policy-switcher';
        nav.setAttribute('aria-label', 'Policy pages');
        links.forEach(function (p) {
          var a = document.createElement('a');
          a.href = p.url;
          a.className = 'policy-switcher-link' + (location.pathname === p.url ? ' active' : '');
          a.textContent = p.title;
          nav.appendChild(a);
        });
        container.insertBefore(nav, body);
      }
    } catch (e) {}
  }

  var wrap = document.createElement('div');
  wrap.className = 'policy-body-wrap';
  var toc = document.createElement('aside');
  toc.className = 'policy-toc';
  toc.id = 'policyToc';
  var tocLabel = document.createElement('p');
  tocLabel.className = 'policy-toc-label';
  tocLabel.textContent = 'On this page';
  var tocList = document.createElement('ol');
  tocList.className = 'policy-toc-list';
  tocList.id = 'policyTocList';
  toc.appendChild(tocLabel);
  toc.appendChild(tocList);

  body.parentNode.insertBefore(wrap, body);
  wrap.appendChild(toc);
  wrap.appendChild(body);

  var clauseNums = Array.prototype.slice.call(rte.querySelectorAll('.clause-num'));
  var items = [];

  clauseNums.forEach(function (numEl, i) {
    var numText = numEl.textContent.trim();
    if (!numText) return;

    var label = '';
    var el = numEl.nextElementSibling;
    var stop = clauseNums[i + 1] || null;
    while (el && el !== stop) {
      if (el.tagName === 'H2' && el.textContent.trim()) {
        label = el.textContent.trim();
        break;
      }
      el = el.nextElementSibling;
    }
    if (!label) return;

    var id = 'clause-' + (items.length + 1);
    numEl.id = id;
    numEl.style.scrollMarginTop = '110px';

    var numMatch = numText.match(/^\d+/);
    var num = numMatch ? numMatch[0] : String(items.length + 1).padStart(2, '0');

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + id;

    var numSpan = document.createElement('span');
    numSpan.className = 'policy-toc-num';
    numSpan.textContent = num;

    var labelSpan = document.createElement('span');
    labelSpan.textContent = label;

    a.appendChild(numSpan);
    a.appendChild(labelSpan);
    li.appendChild(a);
    tocList.appendChild(li);
    items.push({ id: id, link: a });
  });

  if (!items.length) {
    toc.style.display = 'none';
    return;
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === entry.target.id) {
            items.forEach(function (it) { it.link.classList.remove('current'); });
            items[i].link.classList.add('current');
            break;
          }
        }
      });
    }, { rootMargin: '-15% 0px -70% 0px' });

    items.forEach(function (it) {
      var el = document.getElementById(it.id);
      if (el) observer.observe(el);
    });
    items[0].link.classList.add('current');
  }
})();
